// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rj6Yq","col":"styles_col__Zsjdt"};